import React from 'react';
import { Instagram, MessageCircle, Facebook, Leaf } from 'lucide-react';
import { useSiteContent } from '../contexts/SiteContentContext';
export function Footer() {
  const {
    content
  } = useSiteContent();
  const footer = content.footer;
  return <footer className="bg-earth text-cream py-16 px-6 md:px-16" data-id="element-998">
      <div className="max-w-7xl mx-auto" data-id="element-999">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 mb-12" data-id="element-1000">
          <div data-id="element-1001">
            <p className="text-sm text-cream/55 leading-relaxed mb-6" data-id="element-1002">
              {footer.description}
            </p>
          </div>

          <div data-id="element-1003">
            <p className="font-bold text-xs uppercase tracking-widest text-cream/40 mb-5" data-id="element-1004">
              Clases
            </p>
            <ul className="flex flex-col gap-2.5" data-id="element-1005">
              <li data-id="element-1006">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1007">
                  Yoga Presencial
                </a>
              </li>
              <li data-id="element-1008">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1009">
                  Yoga Virtual
                </a>
              </li>
              <li data-id="element-1010">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1011">
                  Paquete Mensual
                </a>
              </li>
              <li data-id="element-1012">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1013">
                  Horarios
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1014">
            <p className="font-bold text-xs uppercase tracking-widest text-cream/40 mb-5" data-id="element-1015">
              Info
            </p>
            <ul className="flex flex-col gap-2.5" data-id="element-1016">
              <li data-id="element-1017">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1018">
                  Sobre mí
                </a>
              </li>
              <li data-id="element-1019">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1020">
                  Ubicaciones
                </a>
              </li>
              <li data-id="element-1021">
                <a href="#faq" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1022">
                  Preguntas frecuentes
                </a>
              </li>
              <li data-id="element-1023">
                <a href="#testimonios" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1024">
                  Testimonios
                </a>
              </li>
            </ul>
          </div>

          <div data-id="element-1025">
            <p className="font-bold text-xs uppercase tracking-widest text-cream/40 mb-5" data-id="element-1026">
              Contacto
            </p>
            <ul className="flex flex-col gap-2.5" data-id="element-1027">
              <li data-id="element-1028">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1029">
                  WhatsApp
                </a>
              </li>
              <li data-id="element-1030">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1031">
                  Email
                </a>
              </li>
              <li data-id="element-1032">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1033">
                  Política de privacidad
                </a>
              </li>
              <li data-id="element-1034">
                <a href="#" className="text-sm text-cream/70 hover:text-cream transition-colors" data-id="element-1035">
                  Términos y cancelación
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-cream/10 flex flex-col md:flex-row justify-between items-center gap-3 text-xs text-cream/35" data-id="element-1036">
          <span data-id="element-1037">{footer.copyrightText}</span>
          <span className="flex items-center gap-1" data-id="element-1038">
            Hecho con <Leaf size={12} data-id="element-1039" /> para tu bienestar
          </span>
        </div>
      </div>
    </footer>;
}